import { ICommandTemplate } from "@formant/core/model/ICommandTemplate";
import { Uuid } from "@formant/core/model/Uuid";

import { ICommandTemplateRank } from "../client/ReorderableCommandTemplateClient";

export function compareCommandDisplayOrder(
    a: ICommandTemplate,
    b: ICommandTemplate,
): number {
    const aOrder = a.displayOrder ?? 0;
    const bOrder = b.displayOrder ?? 0;
    if (aOrder !== bOrder) {
        return aOrder - bOrder;
    }
    return (a.createdAt || "").localeCompare(b.createdAt || "");
}

export function sortCommandTemplatesByDisplayOrder(
    items: ICommandTemplate[],
): ICommandTemplate[] {
    return [...items].sort(compareCommandDisplayOrder);
}

export function reorderCommandDisplayOrders(
    list: ICommandTemplate[],
    moveId: Uuid,
    placement: "before" | "after",
    dropId: Uuid,
): ICommandTemplateRank[] {
    const sorted = sortCommandTemplatesByDisplayOrder(list);
    const movedIdx = sorted.findIndex(it => it.id === moveId);
    const dropIdx = sorted.findIndex(it => it.id === dropId);

    if (movedIdx === -1 || dropIdx === -1 || movedIdx === dropIdx) {
        return [];
    }

    const newSorted = [...sorted];
    const [movedItem] = newSorted.splice(movedIdx, 1);

    let newDropIdx = dropIdx;
    if (placement === "after") {
        newDropIdx += 1;
    }
    if (movedIdx < dropIdx) {
        newDropIdx -= 1;
    }

    newSorted.splice(newDropIdx, 0, movedItem);

    // The bulk reorder endpoint expects the full organization list so ranks
    // stay unique; return nothing when the drop leaves every rank as-is.
    const changed = newSorted.some(
        (item, index) => (item.displayOrder ?? 0) !== index,
    );
    if (!changed) {
        return [];
    }

    return newSorted.map((item, displayOrder) => ({
        id: item.id as Uuid,
        displayOrder,
    }));
}
